import { FounderGuideServiceModule } from 'services/utilities/founderGuide.service';
import { StripHtmlFilterModule } from 'filters/stripHtml.filter';
import { DataServiceModule } from './data.service';

export const MenuServiceModule = angular
    .module('app.services.data.menuService', [
        DataServiceModule,
        FounderGuideServiceModule,
        StripHtmlFilterModule
    ]).service('menuService', (
        dataService,
        settings,
        $filter,
        $timeout,
        founderGuideService
    ) => {
        return {
            getMenus,
            getMenu,
            removeMenu,
            copyMenu,
            save,
            create,
            sanitizeMenu,
            addItem,
            highlightItem
        };

        function getMenus() {
            return dataService.getAll(settings.api.menus);
        }

        function getMenu(id) {
            return dataService.get(settings.api.menus, id);
        }

        function removeMenu(menu) {
            return dataService.remove(settings.api.menus, menu.id);
        }

        function copyMenu(item, nameLength) {
            nameLength = nameLength || 35;
            var strLength = nameLength - 7;
            var copyItem = angular.copy(item);

            copyItem.name = `${item.name.substring(0, strLength)} - COPY`;
            return dataService.create(settings.api.menus, copyItem);
        }

        function save(menu, id, completeTask = true) {
            return dataService.save(settings.api.menus, id, menu).then((data) => {
                if (completeTask) {
                    const MILESTONE = 2;
                    return founderGuideService.completeFounderGuideTask('organize.addMenu', MILESTONE)
                        .then(() => data);
                }

                return data;
            });
        }

        function create(menu) {
            return dataService.create(settings.api.menus, menu);
        }

        function sanitizeMenu(item) {
            if (item.name) {
                item.name = $filter('stripHTML')(item.name);
            }

            if (item.url) {
                item.url = $filter('stripHTML')(item.url);
            }
        }

        function addItem(parent, index, item) {
            parent.splice(index + 1, 0, {
                id: item.id,
                code: item.code,
                name: item.name,
                type: item.type,
                url: item.url,
                items: []
            });
        }

        function highlightItem(parent, index) {
            var itemIndex;
            if (typeof index === 'undefined') {
                itemIndex = 0;
            } else {
                itemIndex = index + 1;
            }

            parent[itemIndex].highlight = true;
            $timeout(() => {
                parent[itemIndex].highlight = false;
            }, 1000);
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/menus.service.js